import { connect } from 'react-redux'
import NumbersUsagePlanSelectStep from './NumbersUsagePlanSelectStep'
import { get, intersection } from 'lodash'

const stateToProps = ({ cms, auth }, { numberType }) => ({
  usagePlans: cms[numberType === '1300' ? 'product1300Plans' : 'product1800Plans']
    .filter(item => {
      const planRoles = item.fields.userRoles
      const userRoles = get(auth, 'user.roles', [])
      // If userRoles is not defined, do not filter
      // Otherwise, show ones where planRoles includes userRoles
      return !planRoles ? true : intersection(userRoles, planRoles).length >= 1
    })
    .map(item => ({
      ...item.fields,
    })),
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(NumbersUsagePlanSelectStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersUsagePlanSelectStep/NumbersUsagePlanSelectStep.container.js